<template>
    <div class="ur-data-grid__content__cell" :style="tdStyle" :class="tdClass" @mousedown.stop="checkRow">
        <div class="ur-data-grid__content__cell__value" :style="valueStyle">
            <ur-icon class="ur-checkbox__icon" :class="checkClass" 
                    :icon="checkIcon" iconType="picto"/>
        </div>
    </div>
</template>

<script>
export default {
    name : 'urDataGridContentCheckCell',
    inject : ['gridInfo','rowInfo'],
    props : {
        field : {type:Object},
        value : null /* type any */
    },
    computed : {
        tdStyle() {
            let style = {};
            style['height'] = this.gridInfo.opts.rowHeight+"px";
            style['flex'] = '0 0 '+this.gridInfo.opts.selectCheckboxWidth+'px';
            style['min-width'] = '0px'
            return style;
        },
        CHECKED_ICON() {return this.gridInfo.opts.checkedIcon},
        UNCHECK_ICON() {return this.gridInfo.opts.uncheckIcon},
        valueStyle() {return {}},
        tdClass()    {return ['ur-data-grid__content__cell--checkbox'];},
        checkIcon()  {return this.value ? this.CHECKED_ICON : this.UNCHECK_ICON},
        checkClass() {return this.value ? 'ur-checkbox__checked' : 'ur-checkbox__unchecked'}
    },
    methods: {
        checkRow(e) {
            //if(!this.gridInfo.opts.selectCheckOnly) return;
            var row = this.rowInfo.row;
            // 1. click mode : default
            if( this.gridInfo.opts.clickMode === 'default') {
                this.gridInfo.func.setSelect(row);
            }
            // 2. click mode : functional
            else if( this.gridInfo.opts.clickMode === 'functional') {
                var shift = e.shiftKey, ctrl = e.ctrlKey;
                if(shift && ctrl) {
                    this.gridInfo.func.setRangeSelect(row, true);
                } else if(shift) {
                    this.gridInfo.func.setRangeSelect(row, false);
                } else if(ctrl) {
                    this.gridInfo.func.setSelect(row);
                } else { // normal click
                    this.gridInfo.func.setSelect(row, false);
                }
            }
            // 3. "FOR IE", shift click -> bypass user-select:none
            if(e.shiftKey) { // 
                e.preventDefault();
                window.getSelection().removeAllRanges(); 
            }
            // x. fire event.
            this.gridInfo.func.fireEvent('check-click', this.gridInfo.sels, e);
        }
    }
}

</script>

